import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Config, UnitLoginResult, UnitType, User } from '../models';
import { ApplicationRoles } from '../tokens/roles.tokens';

@Injectable()
export class ConfigService {
  private configSubject = new BehaviorSubject<Config>(new Config());
  public config: Config;
  public config$ = this.configSubject.asObservable();

  constructor() {
    this.populate();
  }

  // populates the config; this runs once on application startup
  populate() {
    let config = <Config>window['wardsAndStakesConfig'];
    this.config = config;

    // if it's a logged in campus leader, set the account type so the system sees it as such
    if (config.unitType) {
      this.config.account_type = 'ByuiLeader';
    }

    // set the config (which will update the user service)
    this.configSubject.next(config);     
  }

  setConfig(config: Config) {
    this.configSubject.next(config);
    this.config = config;
  }

  getConfig(): Config {
    return this.config;
  }

  hasByuiLeaderToken(): boolean {
    return this.config.account_type === 'ByuiLeader';
  }

  setByuiLeader(loginResult: UnitLoginResult) {
    if (loginResult && loginResult.unitId) {
      const user = new User();
      user.name = loginResult.name + ' ' + loginResult.unitType;
      user.roles = Array<string>();
      user.email = loginResult.email;
      user.roles.push(ApplicationRoles.byuiLeader);

      this.configSubject.value.campusUnitId = loginResult.unitId;
      this.configSubject.value.unitType = loginResult.unitType;
      this.configSubject.value.account_type = 'ByuiLeader';
      this.configSubject.value.user = user;
      this.setConfig(this.configSubject.value);
    }
  }
}
